module.exports = __webpack_public_path__ + "img/umkm.54da6f5b.png";